import type { SVGProps } from 'react'

interface SatelliteIconProps extends SVGProps<SVGSVGElement> {}

export function SatelliteIcon(props: SatelliteIconProps) {
  return (
    <svg
      width={77}
      height={65}
      viewBox="0 0 77 65"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.199 14.38l-.206.402-2.513-1.42V13.1l.178-.088 2.54 1.367zM13.384 14.575l.185.208 6.614-3.74v-.261h-.329l-6.58 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M12.993 14.783v-.262l.315-.214.26.214v.262h-.575z"
        fill="currentColor"
      />
      <path
        d="M20.182 10.46v.322l-6.614 3.74h-.575L10.48 13.1v-.329l6.614-3.732h.576l2.512 1.42zM16.471 16.23l-.212.395-2.513-1.42v-.262l.178-.08 2.547 1.367zM16.65 16.418l.184.207 6.614-3.732v-.261l-.328-.007-6.58 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M16.259 16.625v-.261l.315-.215.26.215v.261h-.575z"
        fill="currentColor"
      />
      <path
        d="M23.448 12.303v.328l-6.614 3.733h-.575l-2.513-1.42v-.322l6.614-3.733h.575l2.513 1.414zM5.927 18.495l-.212.395-2.506-1.414v-.261l.171-.087 2.547 1.367zM6.106 18.683l.185.207 6.614-3.732v-.261l-.33-.007-6.579 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M5.715 18.89v-.261l.322-.214.253.214v.261h-.575z"
        fill="currentColor"
      />
      <path
        d="M12.904 14.568v.329L6.29 18.629h-.575l-2.506-1.414v-.328l6.607-3.733h.575l2.513 1.414zM9.193 20.338l-.212.402-2.506-1.42v-.262l.17-.087 2.548 1.367zM9.378 20.532l.178.208L16.17 17v-.26h-.329l-6.58 3.604.117.188z"
        fill="currentColor"
      />
      <path
        d="M8.98 20.74v-.261l.322-.215.254.215v.26H8.98z"
        fill="currentColor"
      />
      <path
        d="M16.17 16.418v.321l-6.614 3.74H8.98l-2.506-1.421v-.328l6.607-3.733h.575l2.513 1.42zM19.738 18.073l-.212.402-2.513-1.42v-.262l.178-.087 2.547 1.367zM19.916 18.267l.185.208 6.614-3.74v-.26l-.328-.007-6.58 3.612.11.187z"
        fill="currentColor"
      />
      <path
        d="M19.525 18.475v-.261l.315-.222.26.222v.26h-.575z"
        fill="currentColor"
      />
      <path
        d="M26.715 14.153v.321l-6.614 3.74h-.575l-2.513-1.421v-.328l6.614-3.733h.575l2.513 1.42zM12.46 22.187l-.213.395-2.506-1.42V20.9l.171-.087 2.547 1.373zM12.638 22.375l.185.207 6.614-3.732v-.261l-.329-.007-6.58 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M12.247 22.583v-.262l.322-.214.253.214v.262h-.575z"
        fill="currentColor"
      />
      <path
        d="M19.436 18.26v.329l-6.614 3.732h-.575l-2.506-1.42v-.322l6.607-3.74h.576l2.512 1.422zM22.997 19.916l-.206.402-2.513-1.421v-.261l.178-.087 2.54 1.367zM23.182 20.11l.185.208 6.614-3.733v-.261l-.329-.007-6.58 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M22.791 20.318v-.262l.315-.214.26.215v.26h-.575z"
        fill="currentColor"
      />
      <path
        d="M29.98 15.996v.328l-6.614 3.732h-.575l-2.513-1.42v-.322l6.614-3.739h.576l2.512 1.42zM26.262 21.765l-.205.395-2.513-1.414v-.26l.178-.088 2.54 1.367zM26.447 21.953l.185.207 6.614-3.732v-.261l-.328-.007-6.58 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M26.057 22.16V21.9l.315-.214.26.214v.261h-.575z"
        fill="currentColor"
      />
      <path
        d="M33.246 17.838v.329l-6.614 3.732h-.575l-2.513-1.414v-.328l6.614-3.733h.575l2.513 1.414zM29.529 23.608l-.206.402-2.512-1.42v-.262l.178-.087 2.54 1.367zM29.714 23.802l.185.208 6.614-3.74v-.26h-.329l-6.58 3.604.11.188z"
        fill="currentColor"
      />
      <path
        d="M29.323 24.01v-.261l.315-.215.26.215v.261h-.575z"
        fill="currentColor"
      />
      <path
        d="M36.513 19.688v.321l-6.614 3.74h-.576l-2.512-1.421V22l6.614-3.733H34l2.513 1.42zM32.794 25.45l-.205.403-2.513-1.42v-.262l.178-.08 2.54 1.36zM32.98 25.645l.184.208 6.608-3.733v-.261l-.329-.007-6.573 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M32.589 25.853v-.262l.315-.214.26.214v.262h-.575z"
        fill="currentColor"
      />
      <path
        d="M39.771 21.53v.329l-6.607 3.732h-.575l-2.513-1.42v-.322l6.614-3.74h.575l2.506 1.421zM15.725 24.03l-.212.395L13 23.011v-.261l.178-.087 2.547 1.367zM15.903 24.224l.185.201 6.614-3.732v-.262l-.328-.006-6.58 3.605.11.194z"
        fill="currentColor"
      />
      <path
        d="M15.513 24.425v-.254l.322-.221.253.22v.255h-.575z"
        fill="currentColor"
      />
      <path
        d="M22.702 20.103v.328l-6.614 3.74h-.575L13 22.75v-.328l6.614-3.733h.575l2.513 1.414zM18.99 25.873l-.212.402-2.512-1.42v-.262l.178-.087 2.547 1.367zM19.17 26.067l.184.208 6.614-3.74v-.254l-.329-.007-6.58 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M18.778 26.275v-.261l.315-.215.26.215v.26h-.575z"
        fill="currentColor"
      />
      <path
        d="M25.968 21.953v.328l-6.614 3.732h-.576l-2.512-1.42v-.322l6.614-3.739h.575l2.513 1.42zM22.257 27.722l-.212.396-2.513-1.421v-.261l.178-.08 2.547 1.366zM22.436 27.91l.185.207 6.614-3.732v-.261l-.329-.007-6.58 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M22.045 28.118v-.262l.315-.214.26.214v.262h-.575z"
        fill="currentColor"
      />
      <path
        d="M29.234 23.795v.329l-6.614 3.732h-.575l-2.513-1.42v-.322l6.614-3.74h.575l2.513 1.421zM25.523 29.565l-.212.402-2.513-1.42v-.262l.178-.087 2.547 1.367zM25.701 29.76l.185.207 6.614-3.74v-.26h-.328l-6.58 3.605.11.187z"
        fill="currentColor"
      />
      <path
        d="M25.31 29.967v-.261l.322-.221.254.22v.262h-.575z"
        fill="currentColor"
      />
      <path
        d="M32.5 25.645v.322l-6.614 3.739h-.575l-2.513-1.42v-.33l6.614-3.732h.575l2.513 1.421zM39.429 22.315v-.262l.54.945.35.322v.261l-5.676 3.203.794.282v.254l-.342.201-.877-.496-5.744 3.25-2.588-.308v-.261l.459-.08 2.02.267 11.488-6.44-.424-1.138z"
        fill="currentColor"
      />
      <path
        d="M39.429 22.053l.342-.194.548 1.46-5.752 3.25.87.497-.342.194-.877-.496-5.744 3.243-2.588-.301.349-.194 2.02.234 11.598-6.554-.424-1.139zM46.598 47.946l.027.81.199.182.472-.268v-.838l-.698.114z"
        fill="currentColor"
      />
      <path
        d="M46.44 46.96l.342-.013.514.885-.473.275-.712-.885.329-.261z"
        fill="currentColor"
      />
      <path
        d="M46.043 46.532l-.48.275.117.402.623.013.48-.275-.74-.415z"
        fill="currentColor"
      />
      <path
        d="M46.303 47.222l-.74-.415-.52.288v.837l.52.885.74.415.52-.294v-.831l-.52-.885z"
        fill="currentColor"
      />
      <path
        d="M42.634 49.99l.007.254.061.06 3.554-2.003v-.268l-3.622 1.957z"
        fill="currentColor"
      />
      <path
        d="M42.58 49.675l3.505-1.923.171.28-3.553 2.005-.22-.282.096-.08z"
        fill="currentColor"
      />
      <path
        d="M45.851 47.617l-3.546 2.004.04.134h.193l3.546-2.004-.233-.134z"
        fill="currentColor"
      />
      <path
        d="M42.538 49.755l-.233-.134-.164.094v.268l.164.281.233.134.164-.093v-.268l-.164-.282zM41.395 50.888l.027.81.199.181 1.328-.75v-.838l-1.554.597z"
        fill="currentColor"
      />
      <path
        d="M41.237 49.903l1.191-.496.52.884-1.328.75-.712-.877.329-.261z"
        fill="currentColor"
      />
      <path
        d="M41.689 48.991l-1.329.75.117.41.623.013 1.328-.757-.74-.416z"
        fill="currentColor"
      />
      <path
        d="M41.1 50.164l-.74-.422-.52.294v.838l.52.885.74.415.52-.295v-.837l-.52-.878z"
        fill="currentColor"
      />
      <path
        d="M41.64 50.466l-.548-.67-.636-.362-.555.053-.315.442v.718l.315.804.554.67.637.362.548-.047.322-.443v-.723l-.322-.804z"
        fill="currentColor"
      />
      <path
        d="M41.093 50.52l.547-.054.322.804.014 1.166-.822-1.36-.061-.557z"
        fill="currentColor"
      />
      <path
        d="M40.072 49.199l1.02.596.548.67-.363.208-1.088-.83-.117-.644zM38.354 49.005l.322-.59-1.212.1-.548.316.342.267 1.096-.093zM40.73 55.29l.547-.308.699-.971-.699.08-.547 1.2z"
        fill="currentColor"
      />
      <path
        d="M41.811 52.402l.165.034v1.574l-.548.309-.13-1.642.513-.275z"
        fill="currentColor"
      />
      <path
        d="M40.983 50.666l.294.007.699 1.763-.548.308-.808-1.763.363-.315z"
        fill="currentColor"
      />
      <path
        d="M39.634 49.253l.438-.054 1.206 1.474-.548.308-1.397-1.474.301-.254z"
        fill="currentColor"
      />
      <path
        d="M38.128 48.723l.548-.308 1.396.784-.547.308-1.089-.093-.308-.69z"
        fill="currentColor"
      />
      <path
        d="M40.73 50.982l-1.205-1.475-1.397-.784-1.212.108-.691.971v1.575l.691 1.762 1.212 1.468 1.397.79 1.205-.107.698-.971v-1.575l-.698-1.762z"
        fill="currentColor"
      />
      <path
        d="M38.827 46.592l3.28-13.904.533-.73-.595-.336-.78.442-2.698 11.881.232-9.287.356-.73-.588-.342-.712.408v18.642l.588.336.329-.838.055-5.542z"
        fill="currentColor"
      />
      <path
        d="M39.155 46.27l3.486-14.313-.781.442-2.705 11.881V33.927l-.712.402v18.642l.712-.402V46.27z"
        fill="currentColor"
      />
      <path
        d="M40.395 51.176l-1.473-1.796-1.698-.958-1.472.127-.849 1.186v1.916l.85 2.145 1.471 1.789 1.698.958 1.473-.127.848-1.18v-1.923l-.849-2.137z"
        fill="currentColor"
      />
      <path
        d="M38.923 51.316l1.472-.14.849 2.137.048 3.103-2.205-3.632-.164-1.468z"
        fill="currentColor"
      />
      <path
        d="M36.204 47.791l2.718 1.589 1.472 1.795-.965.543-2.574-2.673-.65-1.254zM32.623 46.7l-.143-1.013-3.225.282-.46.261.911.717 2.917-.248zM38.97 63.472l.46-.255 1.862-2.593-.863-.348-1.458 3.196z"
        fill="currentColor"
      />
      <path
        d="M40.846 56.335l.445.08v4.21l-.458.254-.35-4.383.363-.16z"
        fill="currentColor"
      />
      <path
        d="M38.635 51.705l.794.014 1.862 4.697-.458.255-2.157-4.691-.041-.275z"
        fill="currentColor"
      />
      <path
        d="M35.568 47.765l.637.027 3.224 3.926-.458.262-3.739-3.927.336-.288z"
        fill="currentColor"
      />
      <path
        d="M32.02 45.949l.46-.261 3.724 2.104-.459.261-2.903-.261-.822-1.843z"
        fill="currentColor"
      />
      <path
        d="M38.97 51.98l-3.224-3.927-3.725-2.104-3.225.281-1.862 2.594v4.201l1.862 4.697 3.225 3.927 3.724 2.104 3.225-.281 1.863-2.593V56.67l-1.863-4.69zM47.529 33.163l-9.387 5.307V29.8l9.387-5.301v8.664zM34.594 28.915l3.547.884 9.387-5.3-7.668-4.336-9.394 5.3 4.128 3.452z"
        fill="currentColor"
      />
      <path
        d="M38.141 38.47l-7.675-4.335v-8.671l7.675 4.335v8.672zM46.775 32.942l-7.463 4.215v-6.889l7.463-4.215v6.89z"
        fill="currentColor"
      />
      <path
        d="M39.21 30.41l.102-.142 7.463-4.215-.212-.12-7.457 4.215.103.261z"
        fill="currentColor"
      />
      <path
        d="M39.312 37.157l-.206-.12v-6.89l.206.121v6.889zM32.424 34.014l.082 2.654.644.59 4.053-2.292v-2.714l-4.78 1.762z"
        fill="currentColor"
      />
      <path
        d="M31.897 30.811l3.608-1.44 1.698 2.881-4.053 2.292-2.314-2.882 1.061-.85z"
        fill="currentColor"
      />
      <path
        d="M33.102 28.01l-4.053 2.292.383 1.327 2.02.033 4.053-2.291-2.403-1.36z"
        fill="currentColor"
      />
      <path
        d="M31.452 31.662l-2.403-1.36-1.705.958v2.72l1.705 2.882 2.403 1.354 1.698-.958v-2.714l-1.698-2.882z"
        fill="currentColor"
      />
      <path
        d="M35.293 31.415l-1.472-1.796-1.698-.959-1.472.128-.85 1.18v1.922l.85 2.145 1.472 1.789 1.698.958 1.472-.127.849-1.186v-1.917l-.85-2.137z"
        fill="currentColor"
      />
      <path
        d="M33.821 31.548l1.472-.134.85 2.138.04 3.096-2.197-3.625-.165-1.475z"
        fill="currentColor"
      />
      <path
        d="M31.102 28.03l2.719 1.588 1.472 1.796-.966.543-2.574-2.674-.65-1.253zM27.522 26.938l-.144-1.012-3.225.282-.459.254.911.724 2.917-.248zM33.87 43.71l.458-.26 1.855-2.594-.855-.348-1.459 3.203z"
        fill="currentColor"
      />
      <path
        d="M35.745 36.574l.438.074v4.208l-.452.261-.35-4.389.364-.154z"
        fill="currentColor"
      />
      <path
        d="M33.533 31.944l.794.013 1.856 4.691-.452.261-2.157-4.697-.04-.268z"
        fill="currentColor"
      />
      <path
        d="M30.466 28.004l.637.026 3.225 3.927-.459.255-3.738-3.927.335-.281z"
        fill="currentColor"
      />
      <path
        d="M26.919 26.188l.459-.262 3.724 2.104-.458.255-2.91-.255-.815-1.842z"
        fill="currentColor"
      />
      <path
        d="M33.869 32.212l-3.225-3.927-3.725-2.098-3.225.275-1.862 2.593v4.209l1.862 4.697 3.225 3.927 3.725 2.104 3.225-.281 1.862-2.594V36.91l-1.862-4.697z"
        fill="currentColor"
      />
      <path
        d="M33.163 32.614l-2.355-2.868-2.718-1.541-2.355.207-1.363 1.89v3.076l1.363 3.43 2.355 2.869 2.718 1.541 2.355-.208 1.363-1.896v-3.076l-1.363-3.424z"
        fill="currentColor"
      />
      <path
        d="M32.513 32.982l-1.472-1.789-1.698-.965-1.473.134-.849 1.18v1.916l.85 2.145 1.472 1.789 1.698.958 1.472-.127.849-1.18v-1.916l-.85-2.145z"
        fill="currentColor"
      />
      <path
        d="M30.596 33.411l-.815-.455-.575.321v.918l.575.979.815.455.575-.321v-.918l-.575-.979z"
        fill="currentColor"
      />
      <path
        d="M22.689 38.645l.006.322.082.067 7.758-4.383v-.328l-7.846 4.322z"
        fill="currentColor"
      />
      <path
        d="M22.627 38.27l7.71-4.289.198.342-7.757 4.389-.28-.342.13-.1z"
        fill="currentColor"
      />
      <path
        d="M30.049 33.82l-7.765 4.39.048.153.24.007 7.764-4.39-.287-.16z"
        fill="currentColor"
      />
      <path
        d="M22.572 38.37l-.287-.16-.2.113v.322l.2.341.287.161.206-.114v-.321l-.206-.342z"
        fill="currentColor"
      />
      <path
        d="M22.216 39.154l.034.992.24.215.582-.322V39.02l-.856.134z"
        fill="currentColor"
      />
      <path
        d="M22.024 37.955l.41-.007.638 1.072-.582.328-.863-1.072.397-.321z"
        fill="currentColor"
      />
      <path
        d="M21.538 37.439l-.575.328.144.496.753.013.575-.328-.897-.51z"
        fill="currentColor"
      />
      <path
        d="M21.86 38.276l-.897-.509-.637.362v1.012l.637 1.072.897.51.63-.363V39.35l-.63-1.073zM38.778 36.855l-.35.195-.54-1.461v-.261l.308.087 5.436-3.07-.87-.488v-.268h.466l.87.489 5.847-3.297 1.842.207.534-.046v.268l-.35.187-2.012-.234-11.606 6.553.425 1.14z"
        fill="currentColor"
      />
      <path
        d="M38.778 36.594l-.35.201-.54-1.467 5.744-3.244-.87-.495.343-.195.87.496 5.758-3.25 2.588.302-.35.2-2.012-.24-11.606 6.553.425 1.14zM48.425 34.29l-.205.395-2.513-1.414v-.262l.178-.087 2.54 1.367zM48.61 34.477l.185.207 6.608-3.732.006-.262-.335-.006-6.573 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M48.22 34.684v-.26l.315-.215.26.214v.261h-.575z"
        fill="currentColor"
      />
      <path
        d="M55.402 30.362l.007.329-6.614 3.732h-.575l-2.513-1.414v-.328l6.614-3.74h.575l2.506 1.421zM51.69 36.132l-.204.402-2.513-1.42v-.262l.178-.087 2.54 1.367zM51.876 36.326l.185.208 6.614-3.74v-.26h-.335l-6.573 3.605.11.187z"
        fill="currentColor"
      />
      <path
        d="M51.485 36.534v-.261l.315-.222.26.222v.261h-.575z"
        fill="currentColor"
      />
      <path
        d="M58.675 32.212v.321l-6.614 3.74h-.575l-2.513-1.42v-.323l6.614-3.739h.575l2.513 1.42zM54.956 37.975l-.205.402-2.513-1.42v-.262l.178-.087 2.54 1.367zM55.142 38.169l.185.208 6.614-3.733v-.268h-.336l-6.573 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M54.751 38.377v-.261l.315-.215.26.215v.26h-.575z"
        fill="currentColor"
      />
      <path
        d="M61.94 34.055v.321l-6.614 3.74h-.575l-2.513-1.421v-.322l6.614-3.739h.576l2.512 1.42zM58.223 39.824l-.205.402-2.513-1.42v-.262l.178-.087 2.54 1.367zM58.408 40.012l.185.214 6.614-3.739v-.261l-.335-.007-6.573 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M58.018 40.226v-.261l.315-.221.26.22v.262h-.575z"
        fill="currentColor"
      />
      <path
        d="M65.207 35.897v.329l-6.614 3.739h-.575l-2.513-1.42v-.33l6.614-3.732h.575l2.513 1.414zM61.489 41.667l-.206.402-2.513-1.42v-.262l.178-.087 2.54 1.367zM61.674 41.861l.185.208 6.607-3.74v-.26h-.329l-6.572 3.604.109.188z"
        fill="currentColor"
      />
      <path
        d="M61.283 42.069v-.261l.315-.222.26.222v.26h-.575z"
        fill="currentColor"
      />
      <path
        d="M68.466 37.747v.321l-6.608 3.74h-.575l-2.513-1.421v-.322l6.615-3.739h.575l2.506 1.42zM41.154 38.397l-.213.402-2.512-1.42v-.262l.178-.087 2.547 1.367zM41.332 38.591l.185.208 6.614-3.74v-.26h-.328l-6.58 3.605.11.187z"
        fill="currentColor"
      />
      <path
        d="M40.941 38.799v-.261l.315-.215.26.215v.261h-.575z"
        fill="currentColor"
      />
      <path
        d="M48.13 34.477v.321l-6.613 3.74h-.576l-2.512-1.421v-.328l6.614-3.733h.575l2.513 1.42zM44.42 40.24l-.213.402-2.513-1.42v-.255l.178-.088 2.547 1.36zM44.598 40.434l.185.208 6.614-3.733v-.261l-.329-.007-6.58 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M44.207 40.642v-.262l.315-.214.26.215v.26h-.575z"
        fill="currentColor"
      />
      <path
        d="M51.396 36.32v.328l-6.614 3.732h-.575l-2.513-1.413v-.329l6.614-3.74h.575l2.513 1.421zM47.686 42.089l-.212.395-2.513-1.414v-.261l.178-.087 2.547 1.367zM47.864 42.277l.185.207 6.614-3.732v-.261l-.328-.007-6.58 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M47.474 42.484v-.254l.315-.221.26.22v.255h-.575z"
        fill="currentColor"
      />
      <path
        d="M54.663 38.169v.322l-6.614 3.739h-.575l-2.513-1.42v-.33l6.614-3.732h.575l2.513 1.42zM50.952 43.932l-.213.402-2.512-1.42v-.262l.178-.087 2.547 1.367zM51.13 44.126l.185.208 6.614-3.74v-.26H57.6l-6.58 3.604.11.188z"
        fill="currentColor"
      />
      <path
        d="M50.74 44.334v-.261l.314-.215.26.215v.26h-.575z"
        fill="currentColor"
      />
      <path
        d="M57.928 40.012v.321l-6.613 3.74h-.576l-2.512-1.421v-.322l6.614-3.739h.575l2.513 1.42zM54.217 45.775l-.212.402-2.513-1.414V44.5l.178-.087 2.547 1.36zM54.396 45.97l.184.207 6.615-3.733v-.261l-.329-.007-6.58 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M54.005 46.177v-.262l.315-.214.26.214v.262h-.575z"
        fill="currentColor"
      />
      <path
        d="M61.194 41.855v.328l-6.614 3.732h-.575l-2.513-1.413v-.329l6.614-3.732h.575l2.513 1.414zM64.754 43.51l-.205.402-2.513-1.42v-.262l.178-.08 2.54 1.36zM64.94 43.704l.184.208 6.608-3.733v-.26l-.329-.008-6.573 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M64.549 43.912v-.261l.315-.215.26.215v.26h-.575z"
        fill="currentColor"
      />
      <path
        d="M71.731 39.59v.328l-6.607 3.733h-.575l-2.513-1.421v-.322l6.614-3.732h.575l2.506 1.414zM68.02 45.36l-.204.401-2.513-1.42v-.262l.17-.087 2.548 1.367zM68.206 45.553l.185.208 6.607-3.739v-.261h-.328l-6.573 3.605.11.188z"
        fill="currentColor"
      />
      <path
        d="M67.815 45.761v-.268l.315-.214.26.214v.268h-.575z"
        fill="currentColor"
      />
      <path
        d="M74.998 41.44v.32l-6.607 3.733h-.576l-2.512-1.414v-.328l6.614-3.732h.575l2.506 1.42zM57.484 47.624l-.212.402-2.513-1.42v-.262l.178-.087 2.547 1.367zM57.662 47.819l.185.207 6.614-3.739v-.261l-.328-.007-6.58 3.612.11.188z"
        fill="currentColor"
      />
      <path
        d="M57.272 48.026v-.261l.314-.221.26.22v.262h-.574z"
        fill="currentColor"
      />
      <path
        d="M64.46 43.704v.322l-6.613 3.739h-.575l-2.513-1.42v-.33l6.614-3.732h.575l2.513 1.421zM60.743 49.467l-.206.402-2.513-1.42v-.262l.178-.087 2.54 1.367zM60.928 49.661l.185.208 6.614-3.733v-.26l-.329-.008-6.58 3.606.11.187z"
        fill="currentColor"
      />
      <path
        d="M60.537 49.87v-.262l.315-.215.26.215v.261h-.575z"
        fill="currentColor"
      />
      <path
        d="M67.726 45.547v.328l-6.614 3.733h-.575l-2.513-1.421v-.322l6.614-3.739h.576l2.512 1.42zM46.611 3.37l.02.811.2.181.479-.268v-.837l-.699.114z"
        fill="currentColor"
      />
      <path
        d="M46.447 2.385l.342-.013.52.885-.479.274-.705-.884.322-.262z"
        fill="currentColor"
      />
      <path
        d="M46.05 1.957l-.48.274.117.402.623.014.48-.275-.74-.415z"
        fill="currentColor"
      />
      <path
        d="M46.31 2.647l-.74-.416-.52.288v.838l.52.885.74.415.52-.295v-.83l-.52-.885z"
        fill="currentColor"
      />
      <path
        d="M42.648 5.408l.006.26.062.061 3.547-2.003v-.268l-3.615 1.95z"
        fill="currentColor"
      />
      <path
        d="M42.593 5.1l3.505-1.924.165.281-3.547 2.004-.226-.281.103-.08z"
        fill="currentColor"
      />
      <path
        d="M45.865 3.042l-3.553 2.004.04.134h.2l3.546-2.004-.233-.134z"
        fill="currentColor"
      />
      <path
        d="M42.551 5.18l-.24-.134-.163.093v.269l.164.28.24.135.164-.094v-.268l-.165-.281zM41.408 6.312l.02.811.2.181 1.334-.75v-.838l-1.554.596z"
        fill="currentColor"
      />
      <path
        d="M41.244 5.32l1.191-.489.527.885-1.335.757-.712-.884.329-.269z"
        fill="currentColor"
      />
      <path
        d="M41.702 4.416l-1.335.75.117.409.623.013 1.328-.757-.733-.415z"
        fill="currentColor"
      />
      <path
        d="M41.106 5.588l-.739-.422-.52.302v.83l.52.885.74.416.52-.295v-.831l-.52-.885z"
        fill="currentColor"
      />
      <path
        d="M41.654 5.897l-.555-.677-.637-.355-.547.047-.322.442v.717l.322.804.547.67.637.362.555-.047.315-.449v-.717l-.315-.797z"
        fill="currentColor"
      />
      <path
        d="M41.1 5.944l.554-.047.315.797.02 1.166-.828-1.36-.061-.556z"
        fill="currentColor"
      />
      <path
        d="M40.08 4.624l1.02.596.554.677-.363.2-1.095-.83-.117-.643zM38.36 4.43l.322-.59-1.205.1-.547.308.335.275 1.096-.094zM40.743 10.715l.548-.308.698-.972-.698.08-.548 1.2z"
        fill="currentColor"
      />
      <path
        d="M41.818 7.827l.171.033v1.575l-.547.308-.13-1.642.506-.274z"
        fill="currentColor"
      />
      <path
        d="M40.99 6.091l.301.007.699 1.762-.548.308-.808-1.762.356-.315z"
        fill="currentColor"
      />
      <path
        d="M39.648 4.677l.431-.053 1.212 1.474-.548.308-1.403-1.474.308-.255z"
        fill="currentColor"
      />
      <path
        d="M38.135 4.148l.547-.308 1.397.784-.547.308-1.09-.094-.307-.69z"
        fill="currentColor"
      />
      <path
        d="M40.743 6.406l-1.211-1.474-1.397-.784-1.205.1-.699.972v1.582l.699 1.762 1.205 1.467 1.397.791 1.212-.107.698-.972V8.17l-.699-1.763z"
        fill="currentColor"
      />
      <path
        d="M38.566 12.571l.362-2.164-.157-3.465-.288-.315-.63.054v18.642l.59.335.253-.817-.13-10.273 2.697 8.825.596.335.185-.777-3.478-10.38z"
        fill="currentColor"
      />
      <path
        d="M38.942 6.949l-.5.067-.589-.335.713-.402.588.335-.212.335z"
        fill="currentColor"
      />
      <path
        d="M39.154 12.913v-6.3l-.712.403v18.642l.712-.402V14.903l2.705 8.825.78-.435-3.485-10.38zM31.268 15.017l-.493-.596-.569-.322-.486.04-.287.395v.644l.287.71.486.596.569.322.493-.04.28-.395v-.644l-.28-.71z"
        fill="currentColor"
      />
      <path
        d="M30.774 15.064l.493-.047.281.71.014 1.039-.733-1.213-.055-.49z"
        fill="currentColor"
      />
      <path
        d="M29.871 13.891l.904.53.493.596-.322.18-.972-.736-.103-.57zM28.337 13.71l.288-.523-1.075.094-.486.275.3.241.973-.087zM30.453 19.305l.493-.268.616-.87-.616.073-.493 1.065z"
        fill="currentColor"
      />
      <path
        d="M31.418 16.739l.143.027v1.4l-.486.275-.116-1.46.459-.242zM30.678 15.191l.267.007.616 1.568-.486.275-.719-1.568.322-.282z"
        fill="currentColor"
      />
      <path
        d="M29.48 13.931l.391-.04 1.075 1.307-.493.275-1.246-1.314.274-.228z"
        fill="currentColor"
      />
      <path
        d="M28.139 13.462l.486-.274 1.246.703-.493.268-.965-.08-.274-.617z"
        fill="currentColor"
      />
      <path
        d="M30.453 15.473l-1.075-1.314-1.24-.697-1.075.094-.623.864v1.4l.623 1.569 1.075 1.307 1.24.703 1.075-.094.623-.864v-1.4l-.623-1.569zM28.138 10.078l-.35-.422-.403-.228-.35.027-.205.281v.456l.206.516.349.422.404.228.349-.027.205-.281v-.456l-.205-.516z"
        fill="currentColor"
      />
      <path
        d="M27.79 10.112l.348-.034.206.516.006.737-.52-.864-.04-.355z"
        fill="currentColor"
      />
      <path
        d="M27.139 9.274l.65.382.35.422-.233.134-.692-.53-.075-.408zM26.05 9.153l.206-.382-.767.067-.35.202.213.167.698-.054zM27.564 13.147l.342-.194.445-.623-.445.053-.342.764z"
        fill="currentColor"
      />
      <path
        d="M28.248 11.311l.102.02v.999l-.342.2-.09-1.044.33-.175z"
        fill="currentColor"
      />
      <path
        d="M27.721 10.206l.185.006.445 1.12-.342.194-.52-1.12.232-.2z"
        fill="currentColor"
      />
      <path
        d="M26.865 9.308l.273-.034.767.938-.342.195-.89-.938.192-.161z"
        fill="currentColor"
      />
      <path
        d="M25.906 8.973l.35-.202.883.503-.343.194-.691-.06-.199-.435z"
        fill="currentColor"
      />
      <path
        d="M27.563 10.406l-.767-.938-.89-.496-.767.067-.445.617v1.005l.445 1.112.767.939.89.502.767-.067.445-.616v-1.006l-.445-1.119zM40.401 6.6l-1.465-1.795-1.698-.959-1.472.128-.849 1.186v1.916l.849 2.145 1.472 1.789 1.698.958 1.465-.127.856-1.18V8.738l-.856-2.137z"
        fill="currentColor"
      />
      <path
        d="M38.937 6.741l1.465-.14.856 2.137.04 3.103-2.197-3.632-.164-1.468z"
        fill="currentColor"
      />
      <path
        d="M36.21 3.216l2.726 1.588L40.401 6.6l-.965.543L36.86 4.47l-.65-1.253zM32.63 2.124l-.137-1.012-3.225.282-.458.261.903.717 2.917-.248zM38.977 18.897l.46-.255 1.862-2.593-.856-.349-1.465 3.197z"
        fill="currentColor"
      />
      <path
        d="M40.86 11.76l.438.08v4.209l-.452.255-.349-4.383.363-.16z"
        fill="currentColor"
      />
      <path
        d="M38.648 7.13l.788.013 1.862 4.698-.452.254-2.156-4.69-.042-.275z"
        fill="currentColor"
      />
      <path
        d="M35.575 3.19l.636.026 3.225 3.927-.458.262-3.732-3.927.329-.288z"
        fill="currentColor"
      />
      <path
        d="M32.034 1.374l.459-.262 3.718 2.104-.452.262-2.91-.262-.815-1.842z"
        fill="currentColor"
      />
      <path
        d="M38.977 7.404L35.76 3.478l-3.724-2.104-3.225.281-1.863 2.587V8.45l1.863 4.697 3.225 3.927 3.724 2.104 3.218-.281 1.87-2.594v-4.208l-1.87-4.69z"
        fill="currentColor"
      />
    </svg>
  )
}
